module.exports = __webpack_public_path__ + "logo.png?82b9c7a5a3f405032b1db71a25f67021";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 15
// module chunks = 0